import {Component, effect, inject, signal} from '@angular/core';
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NavButtonComponent} from "src/app/presentation/main-view/nav-bar/nav-button/nav-button.component";
import {WeatherWidgetComponent} from "src/app/presentation/common/weather-widget/weather-widget.component";
import {MoovementSvgComponent} from "src/app/presentation/common/icons/moovement-svg/moovement-svg.component";
import {SearchBarComponent} from "src/app/presentation/common/search-bar/search-bar.component";
import {NavBarStateStore} from 'src/app/presentation/main-view/nav-bar/nav-bar-state/nav-bar-state.store';
import {NavigationEnd, Router} from '@angular/router';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {FathomService} from 'src/app/analytics/fathom.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AssetsStore} from 'src/app/domain/assets/assets.store';

@Component({
  selector: 'app-nav-bar',
  imports: [
    NgbModule,
    NavButtonComponent,
    WeatherWidgetComponent,
    WeatherWidgetComponent,
    MoovementSvgComponent,
    SearchBarComponent
  ],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.css'
})
export class NavBarComponent {

  loading = signal(true);
  disabled = signal(false);
  path = signal<string | undefined>(undefined);

  informationCenterVisible = signal(false);
  mapVisible = signal(false);
  notificationsVisible = signal(false);

  mainViewStore = inject(MainViewStore);
  navBarStore = inject(NavBarStateStore);

  private readonly assetsStore = inject(AssetsStore);
  private readonly router = inject(Router);
  private readonly fathomService = inject(FathomService);

  constructor() {
    effect(() => {
      this.disabled.set(this.loading() || !this.navBarStore.enabled());
    });

    effect(() => {
      this.loading.set(this.assetsStore.loading());
    });

    this.path.set(this.router.url);
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.path.set(event.urlAfterRedirects);
      }
    });

    effect(() => {
      const childComponentVisible = this.mainViewStore.childComponentVisible();
      const path = this.path();
      this.informationCenterVisible.set(childComponentVisible && path === '/main/information-center');
      this.mapVisible.set(!childComponentVisible);
      this.notificationsVisible.set(childComponentVisible && path === '/main/notifications');
    });
  }

  toggleInformationCenter() {
    const informationCenterVisible = this.informationCenterVisible();
    if (informationCenterVisible) {
      this.mainViewStore.hideChildComponent();
    } else {
      this.navigate('/main/information-center');
    }
  }

  toggleMap() {
    const mapVisible = this.mapVisible();
    this.fathomService.trackEvent('Toggle full-screen map')
    if (mapVisible) {
      this.mainViewStore.showChildComponent();
    } else {
      this.mainViewStore.hideChildComponent();
    }
  }

  toggleNotifications() {
    const notificationsVisible = this.notificationsVisible();
    if (notificationsVisible) {
      this.mainViewStore.hideChildComponent();
    } else {
      this.navigate('/main/notifications');
    }
  }

  navigate(url: string): void {
    if (this.disabled()) return;

    this.mainViewStore.showChildComponent();
    this.router.navigate([url]);
  }
}
